import React  from "react";

function Apply() {
  return (
    <>
      <div className="apply">
        <div className="container">
          <div className="row justify-content-between align-items-center ">
            <div
              className="col-xl-7 wow fadeInUp"
              data-wow-duration="0.4s"
              data-wow-delay="0.4s"
            >
              <div className="content">
                <h3 className="apply-head">Thousands Need a Helping Hand</h3>
                <p className="text">let's change the world With humanity</p>
              </div>
            </div>
            <div
              className="col-lg-3 wow fadeInUp"
              data-wow-duration="0.5s"
              data-wow-delay="0.5s"
            >
              <a href="#donation" className="button-1">
                Help With Donation
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Apply;
